import { render, staticRenderFns } from "./sTextarea.vue?vue&type=template&id=c3c60c3c&"
import script from "./sTextarea.vue?vue&type=script&lang=js&"
export * from "./sTextarea.vue?vue&type=script&lang=js&"
import style0 from "./sTextarea.vue?vue&type=style&index=0&id=c3c60c3c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports